import Vue from 'vue';

export const RelatorioService = {
  exportarRelatorio(tipo, formato, parametros) {
    let url = `/relatorio/exportar?tipo=${tipo}&formato=${formato}`;
    if (parametros.periodoLetivo) {
        url += `&periodoLetivo=${parametros.periodoLetivo}`;
    }
    if (parametros.modulo) {
        url += `&modulo=${parametros.modulo}`;
    }
    if (parametros.idBloco) {
        url += `&idBloco=${parametros.idBloco}`;
    }
    if (parametros.idCorredor) {
        url += `&idCorredor=${parametros.idCorredor}`;
    }

    return Vue.prototype.$http.get(url, {
      responseType: 'blob'
    });
  }
};
